export enum OfferSettingsItemType {
  DATE = 'DATE',
  USER_SHORT = 'USER_SHORT',
  OFFER_DATA = 'OFFER_DATA',
  CUSTOMER_DATA = 'CUSTOMER_DATA',
  FREE_TEXT = 'FREE_TEXT',
  VERSION_NUMBER = 'VERSION_NUMBER',
  OFFER_NUMBER = 'OFFER_NUMBER'
}
